import './profile.css'
import {useAuthValue} from './AuthContext'
//import { signOut } from 'firebase/auth' 
import { db } from './firebase'
import {useState,  useRef} from 'react'

import {
  collection,
  getDocs,
 // doc,
 // getDoc,
 // addDoc,
  //updateDoc,
  //deleteDoc,
  //doc,
 query,
 where
} from "firebase/firestore";
import {useNavigate, useLocation} from 'react-router-dom'
import InputMask from 'react-input-mask';
import { NumericFormat } from 'react-number-format';
//import CurrencyInput from 'react-currency-masked-input'

import logoImg1 from './assets/logoG.png';

function QueryFone() {
    const [telefone, setTelefone] = useState('')
    const [valorserv, setValorserv] = useState(0)
    const inputRef = useRef(null)
    const inputRefval = useRef(null)
    
    const navigate = useNavigate()
    const location = useLocation()
    const [visible, setVisible] =  useState(false);
    const [clidata, setClidata] = useState([]);
    const [cliuid, setCliuid] = useState('');
    const {currentUser} = useAuthValue()

/*    console.log("Empresa Vinc: "+location.state.empresaVinc)
    console.log("Email User Lanca Cash: "+location.state.emailUser)
    console.log("Empresa vinculada: "+location.state.grupoparc)
    console.log("servico "+valorserv) */
   // const {id,name} = useParams()
/*
    const queryCli = async () => {
        const data = await getDocs(groupsCollectionRef)
        //loop through documents in collection
        setGrupos(
            data.docs.map((doc) => ({ ...doc.data(), key: doc.id }))
        )
        if (loading) {
          setLoading(false);
        }
    } */
    const queryClie = async (valuefone) => {
        const q = query(collection(db, "usuarios"), where("foneUser", "==", valuefone.telefone));
       // console.log(valuefone.telefone);
       // alert(inputRef.current.value)
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
            alert("Cliente nao encontrado ou não cadastrado")
            setVisible(false)
          } else {
        querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            console.log(doc.id, " => ", doc.data());
            setClidata(doc.data())
            setCliuid(doc.id)
          });
          setVisible(!visible)
        }
    }

    const toConfirmCash=(idu, nomeuser, valserv, responsLancCash, grupoCliente, empresavinc, nomeUserReg, foneuser, mailcl)=>{
      if (valorserv < 1) {
        alert("O valor informado do serviço é inválido")
      }else{
        navigate('/confirmDataCash',{state:{idcli:idu,name:nomeuser,valor: valserv, UIDresponLanc:responsLancCash, grupoCli: grupoCliente,empVinc: empresavinc, nomeUsrReg: nomeUserReg, foneUser: foneuser, emailcli:mailcl}});
      }
      
    }

  return (
      <div className='center'>
        <div className='profile'>
          <img src={logoImg1} width="150" height="150" alt='Logo'/>
          <h1>Consulta Telefone</h1>
           <p><strong>Informe abaixo o número telefone do seu cliente para consultar: </strong></p>
       
           <InputMask
              mask='(99) 99999-9999'
              placeholder='Informe seu telefone'
              value={telefone}
              ref={inputRef}
              keyboard="number"
              required
              onChange={e => setTelefone(e.target.value)} style={{ height:40, fontSize: 16, padding:10 }}/>  

        <div style={{alignContent:"center", marginBottom:"12px", marginTop:"10px"}}><button onClick={() => queryClie({telefone})} style={{backgroundColor:"skyblue", color:"darkblue"}}>Consultar</button> - || - <button onClick={() => navigate('/login')} style={{backgroundColor:"darkred",  color:'white'}}>Voltar</button>  </div>
      
          {visible && <div><b>Dados do Cliente:</b><br/>
            <p><b>Nome:</b> {clidata.nomeUser}</p>
            <p><b>Grupo:</b> {clidata.grupoparceiro}</p>
            <p><b>E-mail:</b> {clidata.emailUser}</p>
            <p><b>Plataforma:</b> {clidata.platformuser} - <b>Cliente desde:</b> {new Date( clidata.dataCadastro.seconds * 1000).toLocaleString( "pt-BR",
    {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    })} </p>
       <h1>Informe o valor do serviço prestado</h1>
            <NumericFormat
              style={{ height:40, fontSize: 16, padding:10 , marginRight:15}} 
              prefix="R$ " 
              allowLeadingZeros 
              placeholder='Valor do Serviço'
              value={valorserv}
              refs={inputRefval}
              thousandsGroupStyle="thousand" 
              decimalSeparator="."
              decimalScale={2}
              required
              onChange={e => setValorserv(e.target.value)} /> 

              <button onClick={() => toConfirmCash(cliuid,clidata.nomeUser, valorserv, currentUser.uid, clidata.grupoparceiro, location.state.empresaVinc, location.state.nomeUser, telefone, clidata.emailUser)} style={{backgroundColor:"green", color:'white'}}>Registrar</button>
          </div>}
      </div>
      </div>
  )
}

export default QueryFone;
